import React from "react";
import { observer } from "mobx-react";
import "./PushNotificationsTab.scss";

const PushNotificationsTab = () => <div className="push-notifications-tab">PUSH NOTIFICATIONS</div>;

export default observer(PushNotificationsTab);
